import React from 'react'

import SchoolIcon from '@mui/icons-material/School'

import { CourseCardStyle } from '../styles'
import CourseModal from '../modals/CourseModal'
import ResourceCard from './ResourceCard'
import { openExternal } from '../../utils/safeUrl'

const CourseCard = (props) => {
    const openResource = () => {
        openExternal(props.link)
        return false;
    }

    return (
        <ResourceCard
            Icon={SchoolIcon}
            cardStyle={CourseCardStyle}
            modal={<CourseModal {...props} />}
            title={props.title}
            description={props.description}
            date={props.pub_date}
            content_tags={props.content_tags}
            medical_specialty_tags={props.medical_specialty_tags}
            is_seminal_work={props.is_seminal_work || props.seminal_work}
            onOpen={openResource}
        />
    )
}

export default CourseCard
